import angular from 'angular';
import ModalComponent from './modal.component';

const modalModule = angular.module('tinaba.common.modal', [])

.component('modal', ModalComponent);

export default modalModule;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/modal/modal.js
 **/